import { AfterViewInit, Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { UserDomain } from '@models/pages/user-domains';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { AtlasToastService } from '@services/atlas-toast.service';
import { ToastContainerDirective } from 'ngx-toastr';

export enum PublishModalField {
  ID_UESR_DOMAIN = 'idUserDomain',
  NAME_FIELD = 'name'
}

@Component({
  selector: 'wsb-page-publish-modal',
  templateUrl: './page-publish-modal.component.html',
  styleUrls: ['./page-publish-modal.component.scss'],
  standalone: false
})
export class PagePublishModalComponent implements OnInit, AfterViewInit {
  @ViewChild(ToastContainerDirective) modalToastContainer: ToastContainerDirective;
  @ViewChild(ToastContainerDirective) toastContainer: ToastContainerDirective;

  @Input() public title;
  @Input() public text;
  @Input() public alertText;
  @Input() public labelCancelButton = 'common_cancel';
  @Input() public labelSaveButton = 'common_ok';
  @Input() public domains: UserDomain[];

  @Output() save: EventEmitter<any> = new EventEmitter();
  @Output() cancelEvent: EventEmitter<any> = new EventEmitter();

  pagePublishForm: UntypedFormGroup;
  listDomain: Array<{ idUserDomain: number; domain: string }> = [];
  item: number;

  constructor(private atlasToast: AtlasToastService, private formBuilder: UntypedFormBuilder, public activeModal: NgbActiveModal) {}

  ngOnInit(): void {
    this.setListDomains();
    this.pagePublishForm = this.buildPagePublishForm();
  }

  ngAfterViewInit(): void {
    const text = this.alertText;
    this.atlasToast.info(text, '', -1, this.toastContainer);
  }

  getFormValue() {
    return {
      idUserDomain: this.get(PublishModalField.ID_UESR_DOMAIN),
      name: this.get(PublishModalField.NAME_FIELD)
    };
  }

  private get(value) {
    return this.pagePublishForm.get(value).value;
  }

  private buildPagePublishForm() {
    return this.formBuilder.group({
      idUserDomain: this.formBuilder.control('', []),
      name: this.formBuilder.control('', [Validators.required])
    });
  }

  private setListDomains() {
    if (this.domains) {
      for (const d of this.domains) {
        this.listDomain = [
          ...this.listDomain,
          {
            idUserDomain: d.idUserDomain,
            domain: d.domain
          }
        ];
      }
    }
  }
}
